export interface FlexPriceRequest {
	productId: string;
	subGroupId: string;
	priceNet: number;
	initialDiscountNet: number;
	taxRate: number;
}

export interface FlexPriceResponse {
	net: number;
	gross: number;
	financingPeriod?: number;
	interestRate?: number;
	loanAmount?: number;
	loanCost?: number;
}

/**
 * Calculate Flex (subscription) monthly price from backend
 * Based on the old Vue client implementation
 *
 * @param request - Flex price calculation request
 * @returns Monthly flex price data
 */
export async function calculateFlexPrice(
	request: FlexPriceRequest,
): Promise<FlexPriceResponse> {
	try {
		const response = await fetch(`/configure/price/flex`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(request),
		});

		if (!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`);
		}

		const data = await response.json();
		return data.response;
	} catch (error) {
		console.error("Failed to calculate flex price:", error);

		return {
			net: 0,
			gross: 0,
		};
	}
}